const INSIGHTS = [
  {
    icon: 'ri-temp-cold-line',
    title: 'Best Time to Visit',
    description: 'Summer (June–August) offers Highlands\' famous cool temperatures averaging 75°F — a beloved escape from Southern heat. Fall delivers legendary foliage. Each season reveals a different side of these mountains.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Getting Here',
    description: 'Highlands sits at the intersection of US-64 and NC-28, approximately 2 hours from Atlanta, 3 hours from Charlotte, and 1.5 hours from Asheville. The dramatic approach via Ravenel Bridge from the south is unforgettable.',
  },
  {
    icon: 'ri-restaurant-2-line',
    title: 'Where to Dine',
    description: 'Old Edwards Inn & Spa anchors the fine dining scene with acclaimed Madison\'s restaurant. Central House, The Farm at Old Edwards, and Wolfgang\'s on Main round out a culinary landscape that punches well above a town of 900.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Booking Tips',
    description: 'Summer weekends book out 6–12 months in advance. Fall color peak (mid-October) is the single most competitive booking window. For premium properties, consider a Tuesday–Friday stay to increase availability.',
  },
  {
    icon: 'ri-heart-line',
    title: 'Local Etiquette',
    description: 'Highlands operates on mountain time — things move graciously slow. Reserve dinner before 6pm, yield to wildlife on roads, and leave no trace on the trails. The community\'s charm comes from the people who protect it.',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Waterfall Season',
    description: 'The region receives over 125 inches of rainfall annually — among the highest east of the Mississippi. Waterfalls are most dramatic after late spring rains and throughout early summer. Bridal Veil and Dry Falls are year-round highlights.',
  },
];

export default function LocalInsights() {
  return (
    <section className="bg-[#EDE8E0] py-28 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Local Knowledge</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-none">
              Insider Tips for<br />
              <em className="italic">Highlands, NC</em>
            </h2>
          </div>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-sm">
            The details that make the difference between a good trip and an unforgettable one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {INSIGHTS.map((insight) => (
            <div
              key={insight.title}
              className="bg-[#FAFAF8] rounded-2xl p-8 group hover:bg-[#2D4A3E] transition-colors duration-400"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EDE8E0] group-hover:bg-white/15 mb-6 transition-colors">
                <i className={`${insight.icon} text-[#2D4A3E] group-hover:text-white text-xl transition-colors`} />
              </div>
              <h3 className="font-cormorant text-2xl text-[#1A1A18] group-hover:text-white font-medium mb-3 transition-colors">
                {insight.title}
              </h3>
              <p className="text-[#5C5850] group-hover:text-white/75 text-sm font-jost leading-relaxed transition-colors">
                {insight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}